import { PerakendeFaturaDetayPage } from './../../faturaislemleri/perakende-fatura-detay/perakende-fatura-detay';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { CalendarComponentOptions } from 'ion2-calendar';
import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import moment from 'moment';



@Component({
  selector: 'page-kasa-hareketleri-rapor',
  templateUrl: 'kasa-hareketleri-rapor.html',
})
export class KasaHareketleriRaporPage {
  @ViewChild('sideNavUrunAra') sideNav;
 
  tarih1: any;
  tarih2: any;
  toplamPos:number=0;
  toplamNakit:number=0;
  GirisIslemiTutari: number = 0;
  CikisIslemiTutari: number = 0;
  GirisCikisFarki: number = 0;
  KasaHareketleri = [];
  tarihfilteraktifmi: number = 0;
  girishareketlerilistesi = [];
  cikishareketlerilistesi = [];
  chartVar: any;
  gelirgiderSegment: any;
  sol_segment: any;
  KasaListesi = [];
  aranan="";
  take:number=100;
  skip:number=0;
  baslangic:any;
  bitis:any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
    public navParams: NavParams) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
          this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
          this.tarih2 = localISOTime;
 
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.RaporGetirFiltreli();
    this.gelirgiderSegment = "tümü";
    this.kasaListesi();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }

  RaparGetir() {
    this.toplamNakit=0;
    this.toplamPos=0;
    var formData = new FormData();
    this.dateRange.from.setHours(17);
    formData.append("tarih1",this.ortak.tarih(this.tarih1));
    formData.append("tarih2", this.ortak.tarih(this.tarih2));
    formData.append("tarihfilter", JSON.stringify(this.tarihfilteraktifmi));
 
    this.bllOrtak.islem(formData, "KasaHareketleri", "", true).then(a => {
   
      var sonuc = <any>a;
    
      this.KasaHareketleri = sonuc.SonucObject;

      this.CikisIslemiTutari = 0;
      this.GirisIslemiTutari = 0;
      this.girishareketlerilistesi = this.KasaHareketleri.filter(a => a.IslemTuru == 4 || a.IslemTuru == 10);
      this.girishareketlerilistesi.forEach(element => {
        this.GirisIslemiTutari += parseFloat(element.Tutar.toString());
      })
      this.cikishareketlerilistesi = this.KasaHareketleri.filter(b => b.IslemTuru == 5 || b.IslemTuru == 11);
      // this.cikishareketlerilistesi.forEach(element => {
      //   this.CikisIslemiTutari += parseFloat(element.Tutar.toString());
      //   //  this.showChart();
      //   this.GirisCikisFarki = this.GirisIslemiTutari - this.CikisIslemiTutari;
      // })
      for (let car of this.KasaHareketleri) {
        if(car.Name=="Nakit")
        this.toplamNakit = this.toplamNakit + car.Tutar;
        else if(car.Name=="POS")
        this.toplamPos = this.toplamPos + car.Tutar;
       }
    })
  }
  RaporGetirFiltreli() {
    this.tarihfilteraktifmi = 1;
    var formData = new FormData();
    this.toplamNakit=0;
    this.toplamPos=0;
   
    formData.append("tarih1", this.tarih1);
    formData.append("tarih2",this.tarih2);
  
    formData.append("tarihfilter", JSON.stringify(this.tarihfilteraktifmi));
   
    this.bllOrtak.islem(formData, "KasaHareketleri", "", true).then(a => {
      var sonuc = <any>a;
      this.KasaHareketleri = sonuc.SonucObject;
     
      
      this.CikisIslemiTutari = 0;
      this.GirisIslemiTutari = 0;
      this.girishareketlerilistesi = this.KasaHareketleri.filter(a => a.IslemTuru == 4 || a.IslemTuru == 10);
      this.girishareketlerilistesi.forEach(element => {
        this.GirisIslemiTutari += parseFloat(element.Tutar.toString());
        if (this.GirisIslemiTutari == null) {
          this.GirisIslemiTutari = 0;
        }
      })
      this.cikishareketlerilistesi = this.KasaHareketleri.filter(b => b.IslemTuru == 5 || b.IslemTuru == 11);
      this.cikishareketlerilistesi.forEach(element => {
        this.CikisIslemiTutari += parseFloat(element.Tutar.toString());
        this.GirisCikisFarki = this.GirisIslemiTutari - this.CikisIslemiTutari;
        this.closeNav();

      })
      for (let car of this.KasaHareketleri) {
        if(car.Name=="NAKİT")
        this.toplamNakit = this.toplamNakit + car.Tutar;
        else if(car.Name=="POS")
        this.toplamPos = this.toplamPos + car.Tutar;
       }
      //   this.showChart();
    })

  }
  kasaListesi() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;
     
    })
  }
  DetaylariGoster(hareket)
  {
    let modal=this.modalCtrl.create(PerakendeFaturaDetayPage,{vwFatura3:hareket});
    modal.onDidDismiss(data=>{
      this.ionViewDidLoad();
    })
    modal.present();
  }
  Cikart() {
    var data = [];
    this.KasaHareketleri.forEach(rapor => {
      data.push({
        "Belge No": rapor.BelgeNo,
        "Tür": rapor.Satirtipi ,
        "Cari ADI": rapor.Definition_,
        "Slsman":rapor.SlsMan,
        "Kasa":rapor.Name,
        "Açıklama":rapor.Text,
        "IslemTarihi":rapor.IslemTarihi,
        "Tutar":rapor.Tutar.toFixed(2),
        
      })
    
    });
    this.ortak.ExportExcel(data, "Hareketler - ").then(a => {
    }).catch(x => {
    });
  }

  // dope() {
  //   this.GirisIslemiTutari += 1;
  //   this.showChart();
  // }
  // showChart() {
  //   this.chartVar = new Chart(this.chartCanvas.nativeElement, {
  //     type: 'pie',
  //     data: {
  //       datasets: [{
  //         data: [
  //           this.GirisIslemiTutari,
  //           this.CikisIslemiTutari,

  //         ],
  //         backgroundColor: [
  //           'rgba(30,144,255)',
  //           'rgba(205,51,51)'

  //         ]
  //       }],
  //       labels: [
  //         'Giriş',
  //         'Çıkış'

  //       ]
  //     },
  //     options: {
  //       tooltips: {
  //         enabled: true
  //       }
  //     }
  //   })
  // }
  Islemler(Hareket) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Hareket  İşlemleri',
      buttons: [
       
        {
          text: 'Detaylar',
  
          handler:()=>{
            this.DetaylariGoster(Hareket);
          }
         
        },
       
        {
          text: 'Hareketi Sil',
  
          handler:()=>{
            this.HareketiSil(Hareket);
          }
         
        },{
          text: 'Düzenle',
          handler: () => {
           this.HareketiDuzenle(Hareket);
          }
        },{
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  HareketiSil(Hareket)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", Hareket.ID);
      formData.append("hareket",Hareket.BelgeNo);
      this.bllOrtak.islem(formData, "HareketSil", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.RaporGetirFiltreli();


      }).catch(x => {

        this.ortak.showErrorAlert();
      })
    })
     
  }

  HareketiDuzenle(Hareket)
{

}

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/kasa-hareketleri-rapor/kasa-hareketleri-rapor.ts